import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import TaskAgingDashboard from "../components/TaskAgingDashboard";

function TaskAgingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: '#F8F9FA' }}>
      {/* Header */}
      <header className="bg-white shadow-sm border-b sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-3">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate("/")}
              title="Geri"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <div>
              <h1 className="text-xl font-bold" style={{ fontFamily: 'Manrope', color: '#1F2937' }}>
                ⏰ Görev Yaşlandırma Takibi
              </h1>
              <p className="text-sm text-gray-500">Bekleyen Görevleri Takip Edin</p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-6">
        <TaskAgingDashboard />
      </main>
    </div>
  );
}

export default TaskAgingPage;
